const packages = {
  AlgoliaSearch: [
    {
      tag: 'SCRIPT',
      attributes: {
        src: 'https://cdn.jsdelivr.net/npm/algoliasearch@4.24.0/dist/algoliasearch-lite.umd.js',
        async: true,
        type: 'text/javascript',
        integrity: 'sha256-b2n6oSgG4C1stMT/yc/ChGszs9EY/Mhs6oltEjQbFCQ=',
        crossorigin: 'anonymous',
      },
    },
    {
      tag: 'SCRIPT',
      attributes: {
        src: 'https://cdn.jsdelivr.net/npm/instantsearch.js@4.74.1/dist/instantsearch.production.min.js',
        async: true,
        type: 'text/javascript',
        integrity: 'sha256-r98rA6Km17Ca3hB+9LKS2ywAZuv/6+X0oF6h1iRTlqs=',
        crossorigin: 'anonymous',
      },
    },
    {
      tag: 'SCRIPT',
      attributes: {
        src: 'https://cdn.jsdelivr.net/npm/@algolia/autocomplete-js@1.17.4/dist/umd/index.production.js',
        async: true,
        type: 'text/javascript',
        integrity: 'sha256-E5VTDZxp0Tq5ayOt9uHzrqqEzXOL5VJl+0QOJSBnn4Q=',
        crossorigin: 'anonymous',
      },
    },
    {
      tag: 'SCRIPT',
      attributes: {
        src: 'https://cdn.jsdelivr.net/npm/@algolia/autocomplete-plugin-query-suggestions@1.17.4/dist/umd/index.production.js',
        async: true,
        type: 'text/javascript',
        integrity: 'sha256-+zshgCJ9l7NdLUZXhUhr3GJkl27v02UAY5oD80vMYWs=',
        crossorigin: 'anonymous',
      },
    },
  ],
  zxcvbn: [
    {
      tag: 'SCRIPT',
      attributes: {
        src: window.theme.assets.zxcvbn,
        async: true,
        type: 'text/javascript',
      },
    },
  ],
};

window.hasLoaded = {
  packages: {},
};

window.isLoading = {
  packages: {},
};

const loadScript = (script) =>
  new Promise((resolve, reject) => {
    const firstScriptTag = document.getElementsByTagName('script')[0];

    script.addEventListener('load', resolve);
    script.addEventListener('error', reject);

    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
  });

const loadPackage = (name) => {
  if (name in packages === false) Promise.reject(new Error(`Package: '${name}' not found`));

  const scriptsToLoad = packages[name].reverse().map(({ tag, attributes }) => {
    const script = document.createElement(tag);

    Object.keys(attributes).forEach((attributeName) => {
      script.setAttribute(attributeName, attributes[attributeName]);
    });

    return script;
  });

  return Promise.all(scriptsToLoad.map(loadScript));
};

document.addEventListener('package:load', async (e) => {
  const { name } = e.detail;

  window.isLoading.packages[name] = true;

  try {
    await loadPackage(name);

    window.hasLoaded.packages[name] = true;
    window.isLoading.packages[name] = false;

    document.dispatchEvent(new CustomEvent(`package:loaded:${name}`, { cancelable: true }));
  } catch (error) {
    document.dispatchEvent(
      new CustomEvent(`package:failed:${name}`, { cancelable: true, detail: { error } }),
    );
  }
});
